import cn from 'classnames';
import type React from 'react';
import * as st from './styles.module.scss';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'transparent' | 'solid';
  withTransition?: boolean;
  Play?: JSX.Element;
  Menu?: JSX.Element;
  Periodicity?: JSX.Element;
  Duration?: JSX.Element;
  Select?: JSX.Element;
  Schedule?: React.ReactNode;
  alwaysVisible?: boolean;
}

export const ActionWrapper: React.FC<Props> = ({
  Menu,
  Play,
  Periodicity,
  Schedule,
  Duration,
  Select,
  alwaysVisible,
  variant = 'transparent',
  withTransition = true,
  ...props
}) => {
  const onPlayClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => e.stopPropagation();

  return (
    <div className={cn(st.wrapper, st[variant], alwaysVisible && st.visible)} {...props}>
      <div className={cn(st.background, st[variant], !withTransition && st.bgNoTrans)} />
      <div className={st.wrapper__controls}>
        <div className={st.wrapper__menu}>{Menu}</div>
        <div className={st.wrapper__play} onClick={onPlayClick}>
          {Play}
        </div>
        {/* <div className={st.wrapper__time}>{Duration}</div> */}
      </div>
      <div className={st.wrapper__select}>{Select}</div>
      {/* на мобильном разрешении скрываем эти кнопки */}
      <div className={st.wrapper__periodicity}>{Periodicity}</div>
      {Schedule && <div className={st.wrapper__schedule}>{Schedule}</div>}

    </div>
  );
};
